var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Icon from './Icon';
import * as _ from "lodash";
import * as React from 'react';
import styled from 'styled-components';
import { getColor } from '../helpers/ColorHelpers';
var StarContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: pointer;\n    &:hover{\n        svg{\n            stroke:", ";\n        }\n    }\n"], ["\n    display: inline-block;\n    cursor: pointer;\n    &:hover{\n        svg{\n            stroke:", ";\n        }\n    }\n"])), function (props) { return getColor(props, props.theme.colors.accent); });
var RatingSelect = /** @class */ (function (_super) {
    __extends(RatingSelect, _super);
    function RatingSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.setSelected = function (selected) { return function () {
            selected += 1;
            _this.setState({ selected: selected });
            _this.props.vote && _this.props.vote(selected);
        }; };
        _this.state = {
            selected: 0
        };
        return _this;
    }
    RatingSelect.prototype.render = function () {
        var _this = this;
        var _a;
        var maxStars = (_a = this.props.maxStars) !== null && _a !== void 0 ? _a : 5;
        var sel = this.props.value !== undefined ? this.props.value : this.state.selected;
        return (React.createElement(React.Fragment, null, _.times(maxStars, function (i) {
            var _a, _b;
            if (sel >= i + 1)
                return React.createElement(StarContainer, { key: "a-" + i, onClick: _this.setSelected(i) },
                    React.createElement(Icon, { name: "star full", size: (_a = _this.props.size) !== null && _a !== void 0 ? _a : 24 }));
            else
                return React.createElement(StarContainer, { key: "b-" + i, onClick: _this.setSelected(i) },
                    React.createElement(Icon, { name: "star empty", size: (_b = _this.props.size) !== null && _b !== void 0 ? _b : 24, style: { opacity: 0.5 } }));
        })));
    };
    return RatingSelect;
}(React.PureComponent));
export default RatingSelect;
var templateObject_1;
//# sourceMappingURL=RatingSelect.js.map